<template>
  <div class="all_form_block" data-name="achievement">
    <div class="block">
      <div class="name_tools" id="cv-achievement">{{ $store.getters.cv_t('achievement') }}</div>
      <div class="all_form">
        <br/>
        <switch-button v-model="$store.state.cv.hasAchievement"></switch-button>
        <div class="inp_info">
          <div class="div_relative">
            <span v-on:click="$parent.correctLabel($event)">{{ $store.getters.cv_t("achievement") }}</span>
            <textarea
              v-model.trim="$store.state.cv.achievement"
              v-on:input="$parent.correctLabel($event)"
              v-on:keyup.tab="$parent.correctLabel($event)"
              v-on:click="$parent.correctLabel($event)"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import SwitchButton from "../../../../helpers/switch-button";

export default {
  components:{
    SwitchButton
  },
  data() {
    return {
      model: {
        description: ""
      }
    };
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        this.$validator.validate().then(valid => {
          resolve(valid);
        });
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/cv/tools-components/achievement.vue